import { cn } from "@web/lib/utils.ts";

/**
 * Cover / avatar. Covers get a 4px radius and a subtle inset so white art doesn't
 * bleed into the panel — see DESIGN.md.
 */
export function EntityAvatar({
  src,
  alt,
  size = "md",
  rounded = "sm",
  className,
}: {
  src: string | null | undefined;
  alt: string;
  size?: "xs" | "sm" | "md" | "lg";
  rounded?: "sm" | "full";
  className?: string;
}) {
  const sizeClass =
    size === "xs" ? "size-6" : size === "sm" ? "size-8" : size === "lg" ? "size-12" : "size-10";
  return (
    <div
      className={cn(
        "relative shrink-0 overflow-hidden bg-panel-elevated",
        sizeClass,
        rounded === "full" ? "rounded-full" : "rounded-sm",
        className,
      )}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          className="size-full object-cover"
        />
      ) : (
        <div className="size-full bg-line/40" aria-hidden />
      )}
      <div
        className="pointer-events-none absolute inset-0 shadow-inset-cover"
        aria-hidden
      />
    </div>
  );
}
